import get from 'lodash/get';
import { CellRendererParams, ColumnDef } from '../../models';
import { ECPLinkRenderer } from '../../../link/ECPLinkRenderer';
import { DEFAULT_EMPTY_CELL_PLACEHOLDER } from '../../constants';

export const EcpLinkCellRenderer = <TData, TValue>(props: CellRendererParams<TData, TValue>): JSX.Element => {
  const { getValue, data } = props;
  const colDef = props.colDef as ColumnDef<TData, TValue>;
  const id = get(data, 'id') as string;
  const value = getValue?.() as string;

  if (value == null) {
    return <div>{DEFAULT_EMPTY_CELL_PLACEHOLDER}</div>;
  }

  if (id == null) {
    return <div>{value}</div>;
  }

  return <ECPLinkRenderer id={id} value={value} {...colDef?.cellTypeOptions} />;
};
